<template>
    <v-overlay absolute style="background-color: rgba(255, 255, 255, 0.9); z-index: 80">
        <h4 style="color: #e7453e; text-align: center">{{ title }}</h4>
        <div style="color: #000; text-align: left; padding: 25px; font-style: italic">
            {{ text }}
        </div>
        <div class="d-flex justify-content-around">
            <v-btn :loading="false" @click="confirm()" color="#E7453E">Confirmer</v-btn>
            <v-btn class="ml-2" @click="close()">Annuler</v-btn>
        </div>
    </v-overlay>
</template>

<script>
import { sync } from 'vuex-pathify'
export default {
    props: ['inital_title', 'inital_text', 'type', 'code'],
    components: {},

    computed: {},
    watch: {},
    data: () => {
        return {
            text: '',
            title: '',
            show: false,
        }
    },

    mounted() {
        // console.log('firstItem ', this.firstItem)
        if (this.inital_text) this.text = this.inital_text
        this.title = this.inital_title ? this.inital_title : 'Souhaitez-vous vraiment confirmer cette action ?'
        // this.title = this.inital_title ? this.inital_title : "Souhaitez-vous vraiment supprimer la commande en question ?"
    },
    methods: {
        confirm() {
            this.$emit('confirm-action', this.code)
        },
        close() {
            this.$emit('cancel-action', this.code)
        },
    },
    computed: {
        event() {
            return this.timeslot ? this.c_events.find((x) => x.data.id === this.timeslot.id) : null
        },
    },
}
</script>
